<template>
  <div :class="[customClass]">
    <canvas ref="lineChart"></canvas>
  </div>
</template>

<script>
import { Line } from 'vue-chartjs'
import ChartJS from 'chart.js'

export default {
  name: 'LineChart',
  extends: Line,
  props: {
    chartData: {
      type: Object,
      default: () => ({
        labels: [],
        datasets: []
      })
    },
    chartOptions: {
      type: Object,
      default: () => ({
        responsive: true,
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              padding: 25
            }
          }
        }
      })
    },
    customClass: {
      type: String,
      default: ''
    }
  },
  methods: {
    renderCustomChart (data, options) {
      const ctx = this.$refs.lineChart.getContext('2d')
      if (ctx) {
        new ChartJS(ctx, {
          type: 'line',
          data: data,
          options: options
        })
      } else {
        if (process.env.NODE_ENV !== 'test') {
          console.error('Canvas context is not available')
        }
      }
    }
  },
  mounted () {
    this.renderCustomChart(this.chartData, this.chartOptions)
  },
  watch: {
    chartData: function () {
      this.renderCustomChart(this.chartData, this.chartOptions)
    }
  }
}
</script>
